import React from "react";
import { StyledFormField } from "./FormField.styled";
import { CaptionsTyp } from "../../Typography/Typography";
import { theme } from "../../../constants/StyledComponents";

interface FormFieldProps {
  children: React.ReactNode;
  error?: string;
  fixedError?: boolean;
}

export const FormField = ({
  error,
  children,
  fixedError = true,
}: FormFieldProps) => {
  return (
    <StyledFormField>
      {children}
      <div className={fixedError ? "error" : error ? "error" : ""}>
        {error && <CaptionsTyp color={theme.colors.red_1}>{error}</CaptionsTyp>}
      </div>
    </StyledFormField>
  );
};
